import {
  escolaHeaderResponseSchema,
  type EscolaHeaderResponse,
} from '@/features/benchmarking/schemas/benchmarkingHeader';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export type GetBenchmarkingHeaderParams = { escolaId: number };

export const getBenchmarkingHeader = httpGetAdapter<EscolaHeaderResponse, GetBenchmarkingHeaderParams>({
  url: (params) => `/v3/microdados/escola/${params.escolaId}/header`,
  schema: escolaHeaderResponseSchema,
});
